export default __webpack_public_path__ + "static/hero-3a217c251c158d6f0845789b6b5677aa.mp4";